<template>
  <div class="monitoringPanel">
    <div class="menu flex" style="height: 70px;position: fixed;top: 0">
      <div class="item act">
        <i class="iconfont unify-daohangguanli"/>COUNTER系统
      </div>
    </div>
    <div class="view-container">
      <router-view/>
    </div>
  </div>
</template>

<script>

export default {
  name: 'DbConfig',
  props: {},
  created() {

  },
  methods: {
    jumpTo(url){
      window.open(url)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.monitoringPanel {
  .menu {
    margin-left: 20px;

    .item {
      padding: 24px 0;
      margin-right: 80px;
      cursor: pointer;
      font-size: 15px;
      color: #424655;
      transition: 0.3s ease;

      &:hover{
        color: #2054D6;
      }

      .iconfont{
        margin-right: 4px;
      }

      &.act {
        color: #2054D6;
        font-weight: 600;
      }
    }
  }
}

</style>
